import { sceneCameraRef } from './sceneCameraRef';
import { modelWorldBox, projectBoxToClient } from './modelBox';
import { modelRefsRegistry } from '../stores/modelRefsRegistry';
import * as THREE from 'three';

// ============================================================
// G2：区域框选 e2e 调试桥
// - projectModelBoxClient(id)：模型屏幕包围盒（client 坐标，含无渲染组兜底）
// - projectPointClient([x,y,z])：世界点屏幕坐标（client，用于按当前相机推导像素/单位）
// - g2Info()：诊断（canvas/camera/注册组状态）
// ============================================================
export function projectModelBoxClient(
  id: string,
): { left: number; top: number; right: number; bottom: number } | null {
  const cam = sceneCameraRef.get();
  const canvas = document.querySelector('canvas');
  const st = (window as any)?.__commandBusStores?.scene?.getState?.();
  const m = (st?.models ?? []).find((x: any) => x.id === id);
  if (!cam || !canvas || !m) return null;
  const box = modelWorldBox(m);
  if (!box) return null;
  return projectBoxToClient(box, cam, canvas);
}

export function projectPointClient(p: [number, number, number]): { x: number; y: number } | null {
  const cam = sceneCameraRef.get();
  const canvas = document.querySelector('canvas');
  if (!cam || !canvas) return null;
  const bounds = canvas.getBoundingClientRect();
  const v = new THREE.Vector3(p[0], p[1], p[2]).project(cam);
  if (!Number.isFinite(v.x) || !Number.isFinite(v.y)) return null;
  return { x: bounds.left + ((v.x + 1) / 2) * bounds.width, y: bounds.top + ((-v.y + 1) / 2) * bounds.height };
}

export function cameraRight(): [number, number, number] | null {
  const cam = sceneCameraRef.get();
  if (!cam) return null;
  cam.updateMatrixWorld?.(true);
  const e = cam.matrixWorld.elements;
  return [e[0], e[1], e[2]];
}

export function g2Info() {
  const st = (window as any)?.__commandBusStores?.scene?.getState?.();
  const models = (st?.models ?? []).map((m: any) => {
    const group = modelRefsRegistry.get(m.id)?.group ?? null;
    return {
      id: m.id,
      visible: m.visible,
      position: m.position,
      hasGroup: !!group,
      boxEmpty: group ? new THREE.Box3().setFromObject(group).isEmpty() : null,
    };
  });
  return { hasCanvas: !!document.querySelector('canvas'), hasCamera: !!sceneCameraRef.get(), models };
}
